import axios from 'axios';

const BASE_URL = import.meta.env.VITE_REST_URL || 'http://127.0.0.1:8000/api/v1';

// Create an Axios instance configured for Laravel Sanctum
const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
});

// Interceptor to inject the auth token on every request
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('rutex_auth_token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor to handle 401 Unauthorized responses globally
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            const currentPath = window.location.pathname;
            if (!currentPath.includes('/user-pages/login') && !currentPath.includes('/user-pages/register')) {
                localStorage.removeItem('rutex_auth_token');
                localStorage.removeItem('rutex_user');
                window.location.href = '/user-pages/login';
            }
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
